import Vue from 'vue';
import CitiesModal from "./components/cities/CitiesModal";
import CityNotification from "./components/cities/CityNotification";
import {Input} from "element-ui";
import locale from "element-ui/lib/locale/lang/ru-RU";
import {Cookie} from "../../utils/Cookie/Cookie";

Vue.use(Input, {locale});
Vue.use(Cookie);

window.axios = require('axios');
window._ = require('lodash');

if (document.getElementById('menu-with-gamburger')){
    new Vue({
        el: '#menu-with-gamburger',
        components: {
            CitiesModal,
            CityNotification
        },
        data: {
            params: {
                accountHamburger: false,
                menuHamburger: false,
                overflow: false,
            },
        },
        created() {
            window.MenuEvent = new Vue();
        },
        methods: {
            showAccountHamburger(event) {
                if (event.target.classList.contains('city-msg__action')) {
                    return false;
                }

                if (this.$refs.user_menu){
                    this.params.accountHamburger = !this.params.accountHamburger;
                    this.params.menuHamburger = false;
                    this.params.overflow = !this.params.overflow;
                }
            },
            showMenuHamburger(){
                this.params.menuHamburger = !this.params.menuHamburger;
                this.params.accountHamburger = false;
                this.params.overflow = !this.params.overflow;
            },
            closeMenu(){
                this.params.menuHamburger = false;
                this.params.accountHamburger = false;
                this.params.overflow = false;
            },
            openCityModal() {
                MenuEvent.$emit('openCitiesModal');
            }
        }
    });
}
